import { render, staticRenderFns } from "./WallGallery.vue?vue&type=template&id=0a5a299e&scoped=true&"
import script from "./WallGallery.vue?vue&type=script&lang=js&"
export * from "./WallGallery.vue?vue&type=script&lang=js&"
import style0 from "./WallGallery.vue?vue&type=style&index=0&id=0a5a299e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5a299e",
  null
  
)

export default component.exports